<script>
	import { goto } from '@roxi/routify';
	import { successToast, warningToast, failureToast } from '../components/toast.js'
	import { getData, postFormData, postJsonData } from "../helpers.js";

	let passwordResetForm;
	let usernameLoginError = '';
	let passwordLoginError = '';
	// handle login form submission and response
	function handleLogin() {
		let res = postFormData('user/password-reset-request', passwordResetForm);
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				successToast("Check your email for a reset link.")
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				usernameLoginError = errors.username ? errors.username[0] : '';
				passwordLoginError = errors.password ? errors.password[0] : '';
			}
		});
	}
</script>

<main class=background>
	<div class="py-14 px-6 text-center text-6xl font-bold font-mono">
		<img class="mx-auto h-20" src="./ref/padg_lockup.svg" alt="Palo Alto Data Group Logo">
	</div>
	<div class="flex max-w-max mx-auto pb-4">
		<div class="inline-flex flex-col px-2 items-center">
			<div class="card px-8 py-8 lg:px-16 lg:py-16">
				<p class="text-2xl font-semibold text-blue-900 mb-8">eCPR Search</p>
				<form method="POST" class="flex-col" bind:this={passwordResetForm} on:submit|preventDefault={handleLogin}>
					<div class="flex flex-col space-y-6 text-xl h-full box-border">
						<div class="input">
							<div class="relative">
								<input id="username-login" name="username" placeholder="Username or Email" autocomplete="webauthn username" class="peer z-20 placeholder:text-transparent {usernameLoginError === '' ? '' : 'border-red-600'}"/>
								<label for="username-login" class="absolute text-gray-500 font-normal duration-200 transform -translate-y-4 scale-[.65] top-3 z-10 origin-[0] left-2.5 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:font-light peer-focus:scale-[.65] peer-focus:-translate-y-4">Username or Email</label>
							</div>
							<p class='error-text {usernameLoginError === '' ? 'hidden' : ''}'>{usernameLoginError}</p>
						</div>
						<div class="flex space-x-4 justify-between">
							<div>
								<button type="submit"
									class="pb-3 pt-2 text-xl leading-5 px-4 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
									Submit
								</button>
							</div>
							<!-- <button class="w-3/5 pb-3 pt-2 text-xl leading-5 !px-0 rounded-md bg-blue-500 hover:bg-blue-600 cursor-pointer text-gray-100 font-semibold border-none shadow-sm">
								WebAuthn
							</button> -->
						</div>
					</div>
				</form>
				<div class='w-full mt-10'>
					<a class="text-md lg:text-lg font-sans" href="/">
						<button class="bg-gray-100 bg-opacity-70 px-2 py-1 rounded-md shadow-sm">
							&lt;&lt; Back to Main Page
						</button>
					</a>
				</div>
			</div>
			<div class="flex mt-2 font-sans">
				<p class="my-6 m-auto text-gray-200">Copyright 2021-{new Date().getFullYear()} © Palo Alto Data Group</p>
			</div>
		</div>
	</div>
</main>

<style>
	.card {
		@apply rounded-md shadow-lg bg-gray-200 bg-opacity-50;
	}
	main.background {
		background:
			radial-gradient(farthest-side at top left,
				rgba(214, 238, 255, 0.773) 5%, transparent 95%),
			radial-gradient(farthest-side at bottom right,
				rgba(214, 238, 255, 0.773) 5%, transparent 95%);
		background-color:theme("colors.cust_blue.600");
	}
</style>